module.exports = __webpack_public_path__ + "img/yt.dc807bdc.svg";